import { ComposedChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Line } from "recharts";
import styles from "./Dumbell_Chart.module.css";
import { getTopKips } from "../../../services/summary/summaryService";

// const data = [
//   { x: 1, value: 80 },
//   { x: 2, value: 68 },
// ];

const PREV_COLOR = "#94a3b8";
const CURR_COLOR = "#6366f1";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const isPrev = payload[0].payload.x === 1;
  return (
    <div className="bg-white border rounded px-3 py-2 small shadow-sm">
      <strong>{isPrev ? "Previous" : "Current"}</strong>: {payload[0].payload.value}
    </div>
  );
};

const DumbbellChart = ({ prevValue, prevValueN2 }) => {
  const prev = prevValueN2 //data[0].value;
  const curr = prevValue//data[1].value;
  const increased = curr >= prev;
  const connectorColor = increased ? "#22c55e" : "#f43f5e";
  const deltaClass = increased ? "text-success" : "text-danger";



  return (
    <div className={`w-100 ${styles.wrapper}`}>
      {/* <p className={`text-secondary ${styles.subtitle}`}>Can</p> */}
      <h3 className={`fw-bold ${styles.title}`}>Previous vs Current</h3>

      <ResponsiveContainer width="100%" height={100}>
        <ComposedChart data={[
          { x: 1, value: prevValueN2 },
          { x: 2, value: prevValue },
        ]} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
          <XAxis dataKey="x" hide />
          <YAxis hide domain={["auto", "auto"]} />
          <Tooltip content={<CustomTooltip />} cursor={false} />
          <Line
            dataKey="value"
            stroke={connectorColor}
            strokeWidth={3}
            dot={(props) => {
              const { cx, cy, index } = props;
              const color = index === 0 ? PREV_COLOR : CURR_COLOR;
              return (
                <circle key={index} cx={cx} cy={cy} r={10} fill={color} stroke="white" strokeWidth={2} />
              );
            }}
            activeDot={{ r: 13, strokeWidth: 2 }}
          />
        </ComposedChart>
      </ResponsiveContainer>

      <div className={`d-flex justify-content-between align-items-center ${styles.labels}`}>
        <div className={`${styles.labelGroup}`}>
          <div className={styles.labelKey} style={{ color: PREV_COLOR }}>PREVIOUS</div>
          <div className={styles.labelValue}>{prev}</div>
        </div>
        <div className={`fw-semibold ${deltaClass} ${styles.delta}`}>
          {increased ? "▲" : "▼"} {Math.abs(curr - prev)}
        </div>
        <div className={styles.labelGroup}>
          <div className={styles.labelKey} style={{ color: CURR_COLOR }}>CURRENT</div>
          <div className={styles.labelValue}>{curr}</div>
        </div>
      </div>
    </div>
  );
};

export default DumbbellChart;